import React from 'react';
import { createRoot } from 'react-dom/client';
import TrackingCopyingText from '../../src/news_show/tracking_copying_text/tracking_copying_text';
import TrackReadingProgress from '../../src/news_show/track_reading_progress/track_reading_progress';
import AdButler from '../../src/components/react/adbutler/adbutler';
import NewsDetailsShareToolbarHOC from '../../src/news_show/news_details_share_toolbar_hoc/news_details_share_toolbar_hoc';
import ArticleNewsletterSubscription from '../../src/news_show/article_newsletter_subscription/article_newsletter_subscription';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import Tooltip from 'bootstrap/js/dist/tooltip';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('article-root');
  const isSignedIn = JSON.parse(root.dataset.isSignedIn);

  const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipElements.forEach((element) => new Tooltip(element));

  const trackingCopyingText = document.getElementById('tracking-copying-text');
  if (trackingCopyingText) {
    const trackingCopyingTextRoot = createRoot(trackingCopyingText);
    trackingCopyingTextRoot.render(
      <DevexHighOrderComponent>
        <TrackingCopyingText
          querySelector={trackingCopyingText.dataset.querySelector}
          minCopyLength={JSON.parse(trackingCopyingText.dataset.minCopyLength)}
        />
      </DevexHighOrderComponent>
    );
  }

  const trackReadingProgress = document.getElementById('track-reading-progress');
  if (trackReadingProgress) {
    const trackReadingProgressRoot = createRoot(trackReadingProgress);
    trackReadingProgressRoot.render(
      <DevexHighOrderComponent>
        <TrackReadingProgress articleId={trackReadingProgress.dataset.articleId} />
      </DevexHighOrderComponent>
    );
  }

  const adbutlerSidebarSquare = document.getElementById('adbutler-sidebar-square');
  if (adbutlerSidebarSquare) {
    const adbutlerSidebarSquareRoot = createRoot(adbutlerSidebarSquare);
    adbutlerSidebarSquareRoot.render(
      <DevexHighOrderComponent>
        <AdButler
          adbutlerInfo={JSON.parse(adbutlerSidebarSquare.dataset.adbutlerInfo)}
          isSignedIn={isSignedIn}
        />
      </DevexHighOrderComponent>
    );
  }

  const adbutlerSidebarTower = document.getElementById('adbutler-sidebar-tower');
  if (adbutlerSidebarTower) {
    const adbutlerSidebarTowerRoot = createRoot(adbutlerSidebarTower);
    adbutlerSidebarTowerRoot.render(
      <DevexHighOrderComponent>
        <AdButler
          adbutlerInfo={JSON.parse(adbutlerSidebarTower.dataset.adbutlerInfo)}
          isSignedIn={isSignedIn}
        />
      </DevexHighOrderComponent>
    );
  }

  const newsletterSubscriptions = document.querySelectorAll('.newsletter-subscription-component');
  if (newsletterSubscriptions.length) {
    newsletterSubscriptions.forEach((newsletterSubscription) => {
      const newsletterSubscriptionRoot = createRoot(newsletterSubscription);
      newsletterSubscriptionRoot.render(
        <DevexHighOrderComponent>
          <ArticleNewsletterSubscription
            articleId={newsletterSubscription.dataset.articleId}
            isSignedIn={JSON.parse(newsletterSubscription.dataset.isSignedIn)}
          />
        </DevexHighOrderComponent>
      );
    });
  }

  const shareContentToolbar = document.getElementById('share-content-toolbar');
  if (shareContentToolbar) {
    const {
      contentId,
      contentUrl,
      contentTitle,
      contentTeaser,
      showSharingArticle,
      isContentPaywalled,
    } = shareContentToolbar.dataset;

    const shareContentToolbarRoot = createRoot(shareContentToolbar);
    shareContentToolbarRoot.render(
      <NewsDetailsShareToolbarHOC
        contentId={parseInt(contentId)}
        contentUrl={contentUrl}
        contentTitle={contentTitle}
        contentTeaser={contentTeaser}
        showSharingArticle={showSharingArticle === 'true'}
        isContentPaywalled={isContentPaywalled === 'true'}
      />
    );
  }
});
